// extracted by mini-css-extract-plugin
export default {"report":"Report_report__1+1IR","table":"Report_table__hDXYF","expandedRow":"Report_expandedRow__omcbI","hovered":"Report_hovered__ksqrc","subTable":"Report_subTable__CUGU5"};